import Lottie from './Lottie.vue'

export default Vue => {
  Vue.component(Lottie.name, Lottie)
}